import React, { useState } from "react";
import { GoogleLogin } from "react-google-login";
import { XANO_GOOGLE_CLIENT_ID } from "../../config/api_config";
import useInView from "../../hooks/useInView";

const StickyBar = ({ authResponse }) => {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[999999999] mx-auto flex w-full max-w-[1224px] items-center justify-center bg-[#204177] px-4 py-4 transition-transform duration-300 ease-in-out">
      <GoogleLogin
        clientId={XANO_GOOGLE_CLIENT_ID}
        render={(renderProps) => {
          return (
            <div
              className="btn--glow h-12 w-full rounded-lg px-[2px] pb-[2px] md:mx-auto md:w-auto"
              style={{
                boxShadow: "0px 0px 10px 0px rgba(127, 194, 65, 0.35)",
              }}
              onClick={renderProps.onClick}
              disabled={renderProps.disabled}
            >
              {false ? (
                <button className="py-auto flex  h-full w-full w-full items-center justify-center gap-2.5 self-stretch rounded-lg bg-[#7fc241] ">
                  <div className="flex items-center justify-center gap-2 ">
                    <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:0ms]"></span>
                    <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:150ms]"></span>
                    <span className="h-3 w-3 animate-bigbounce rounded-full bg-light_green [animation-delay:300ms]"></span>
                  </div>
                </button>
              ) : (
                <button className="flex h-full w-full items-center  justify-center gap-2 rounded-lg bg-[#7FC241]  py-[10px] text-center text-[18px] font-semibold text-[#121212] md:px-8">
                  <div className="h-7 w-7 rounded-full bg-white">
                    <img
                      src="https://img.learntube.ai/public-assets/Onboarding_Revamp/image%20479.png?updatedAt=1694429827511"
                      width={28}
                      height={28}
                      alt="google icon"
                    />
                  </div>{" "}
                  Start Learning For Free
                </button>
              )}
            </div>
          );
        }}
        onSuccess={(e) => authResponse(e, setIsGoogleLoading)}
        onFailure={(e) => authResponse(e, setIsGoogleLoading)}
        cookiePolicy={"single_host_origin"}
      />
    </div>
  );
};

export default StickyBar;
